import Professional from "../../../models/Professional";
import FormBase from "../../FormBase";
import FormFieldAttachmentBase from "../../../forms/FormFieldAttachmentBase";
import FormFieldBase from "../../../forms/FormFieldBase";
import RefusalPresentVaccineService from "../../../services/RefusalPresentVaccineService";
import ValidationBase, { ValidationType } from "../../../forms/ValidationBase";

export enum ERefusalPresentVaccine {
    TripliceViral = 1,
    Influenza = 2,
    DuplaAdulto = 3,
    HepatiteB = 4,
    Varicela = 5
}

export class RefusalPresentVaccineItem {
    Identifier: string;
    Type: ERefusalPresentVaccine;
    Checked: FormFieldBase;
    Reason: FormFieldBase;
    ApplyDate: FormFieldBase;

    constructor(Identifier: string, Type: ERefusalPresentVaccine, Checked: boolean, Reason: string, ApplyDate?: any) {
        this.Identifier = Identifier;
        this.Checked = new FormFieldBase(Checked, []);
        this.Reason = new FormFieldBase(Reason, []);
        this.ApplyDate = new FormFieldBase(ApplyDate, [new ValidationBase("A data informada é inválida.", ValidationType.DATA)]);
        this.Type = Type;
    }

    static NewInstance(Identifier: string, Type: ERefusalPresentVaccine): RefusalPresentVaccineItem {
        return new RefusalPresentVaccineItem(Identifier, Type, false, "", null);
    }

}

export default class RefusalPresentVaccineForm implements FormBase {

    RefusalPresentVaccineTermItemList: RefusalPresentVaccineItem[];

    constructor() {
        this.RefusalPresentVaccineTermItemList = new Array<RefusalPresentVaccineItem>();
        this.RefusalPresentVaccineTermItemList.push(RefusalPresentVaccineItem.NewInstance("Tríplice viral (Sarampo, caxumba e rubéola)", ERefusalPresentVaccine.TripliceViral));
        this.RefusalPresentVaccineTermItemList.push(RefusalPresentVaccineItem.NewInstance("Influenza", ERefusalPresentVaccine.Influenza));
        this.RefusalPresentVaccineTermItemList.push(RefusalPresentVaccineItem.NewInstance("Dupla adulto", ERefusalPresentVaccine.DuplaAdulto));
        this.RefusalPresentVaccineTermItemList.push(RefusalPresentVaccineItem.NewInstance("Hepatite B", ERefusalPresentVaccine.HepatiteB));
        this.RefusalPresentVaccineTermItemList.push(RefusalPresentVaccineItem.NewInstance("Varicela", ERefusalPresentVaccine.Varicela));
    }


    static NewInstance(): RefusalPresentVaccineForm {
        return new RefusalPresentVaccineForm();
    }

    ValidateToGoNextStep(): string {

        let retorno: string = "";
        if (this.RefusalPresentVaccineTermItemList != null && this.RefusalPresentVaccineTermItemList.length > 0) {
            this.RefusalPresentVaccineTermItemList.forEach((element: RefusalPresentVaccineItem) => {
                if (element.Checked.Value && (element.Reason.Value === "" || (element.ApplyDate.Value === null || element.ApplyDate.Value.toString().trim() === ""))) {
                    retorno = `É preciso preencher todos os campos obrigatórios no "Termo de Recusa em Apresentar Comprovação Vacinal" para a vacina ${element.Identifier}.`;
                }
            });
        }

        return retorno;
    }

    CallInsertOrUpdateApi(professional: Professional, customAttributes?: any): Promise<any> {
        const dataJson = this.getJsonObjet();
        return RefusalPresentVaccineService.postInsertOrUpdateRefusalPresentVaccine(dataJson, professional.Id);
    }

    GetFieldByName(name: string): FormFieldBase | FormFieldAttachmentBase {
        throw new Error("Method not implemented.");
    }

    getJsonObjet() {

        let viewModelList: any[] = [];

        if (this.RefusalPresentVaccineTermItemList != null && this.RefusalPresentVaccineTermItemList.length > 0) {
            this.RefusalPresentVaccineTermItemList.forEach((element: RefusalPresentVaccineItem) => {
                viewModelList.push({
                    "applyDate": element.ApplyDate.Value,
                    "reason": element.Reason.Value,
                    "checked": element.Checked.Value,
                    "refusualPresentVaccineType": element.Type
                })
            });
        }

        return viewModelList;
    }

}